//@ts-check

class TopicList {
  static init() {
    new this();
  }

  constructor() {
    this.listTopics = /** @type {HTMLSelectElement} */ (
      this.getElement("topic-list-topics")
    );
    this.listAvailables = /** @type {HTMLSelectElement} */ (
      this.getElement("topic-list-availables")
    );
    this.buttonUp = this.getElement("topic-list-button-up");
    this.buttonAppend = this.getElement("topic-list-button-append");
    this.buttonRemove = this.getElement("topic-list-button-remove");
    this.buttonDown = this.getElement("topic-list-button-down");
    this.topicDetailTitle = this.getElement("topic-detail-title");
    this.topicDetailImage = /** @type {HTMLImageElement} */ (
      this.getElement("topic-detail-image")
    );
    this.topicDetailDescription = this.getElement("topic-detail-description");
    this.buttonsSave = /** @type {NodeListOf<HTMLButtonElement>} */ (
      document.querySelectorAll(".topic-list-button-save")
    );
    this.form = /** @type {HTMLFormElement} */ (
      this.getElement("topic-list-form")
    );

    this.listTopics.addEventListener("click", (e) => this.onClickListTopics(e));
    this.listAvailables.addEventListener("click", (e) =>
      this.onClickListAvailables(e),
    );
    this.buttonAppend.addEventListener("click", () =>
      this.onClickButtonAppend(),
    );
    this.buttonRemove.addEventListener("click", () =>
      this.onClickButtonRemove(),
    );
    this.buttonUp.addEventListener("click", () => this.onClickButtonUp());
    this.buttonDown.addEventListener("click", () => this.onClickButtonDown());
    this.buttonsSave.forEach((button) =>
      button.addEventListener("click", () => this.onClickButtonSave()),
    );

    this.updateButtonsSave();
    this.updateAvailableTopics();
  }

  /** @param {string} id */
  getElement(id) {
    const element = document.getElementById(id);
    if (!element) throw new Error(`element #${id} not found`);

    return element;
  }

  /** @param {MouseEvent} event */
  onClickListTopics(event) {
    if (event.target instanceof HTMLOptionElement)
      return this.onClickListItem(event.target);
  }

  /** @param {MouseEvent} event */
  onClickListAvailables(event) {
    if (event.target instanceof HTMLOptionElement)
      return this.onClickListItem(event.target);
  }

  /** @param {HTMLOptionElement} option */
  onClickListItem(option) {
    this.fetchTopicInfo(option.value);
  }

  async onClickButtonAppend() {
    if (!this.listAvailables.selectedOptions.length) return;

    for (const option of this.listTopics.options) {
      option.selected = false;
    }

    for (const option of this.listAvailables.selectedOptions) {
      const newOption = /** @type {HTMLOptionElement} */ (
        option.cloneNode(true)
      );
      this.listTopics.add(newOption);
      newOption.selected = true;
    }

    /* 上のforループでまとめて操作すると、ループが1つ飛びになってしまいます */
    for (const option of this.listAvailables.options) {
      option.selected = false;
    }

    this.updateAvailableTopics();

    /* 2フレーム待たないと最下部までスクロールしません */
    await new Promise((r) => requestAnimationFrame(r));
    await new Promise((r) => requestAnimationFrame(r));

    this.listTopics.scrollTo(0, this.listTopics.scrollHeight);
  }

  onClickButtonRemove() {
    const removedIds = [];
    while (this.listTopics.selectedOptions.length) {
      removedIds.push(
        this.listTopics.options[this.listTopics.selectedIndex].value,
      );
      this.listTopics.remove(this.listTopics.selectedIndex);
    }

    for (const option of this.listAvailables.options) {
      option.selected = removedIds.includes(option.value);
    }

    this.updateAvailableTopics();
    this.updateButtonsSave();
  }

  onClickButtonUp() {
    if (!this.listTopics.selectedOptions.length) return;

    const selected = Array.from(this.listTopics.selectedOptions);

    for (let i = 0; i < selected.length; i++) {
      const option = selected[i];
      const index = [].indexOf.call(this.listTopics, option);
      if (index <= selected.indexOf(option)) continue;

      this.listTopics.add(option, index - 1);
    }
  }

  onClickButtonDown() {
    if (!this.listTopics.selectedOptions.length) return;

    const selected = Array.from(this.listTopics.selectedOptions);

    const lengthDiff = this.listTopics.options.length - selected.length;

    for (let i = selected.length - 1; i >= 0; i--) {
      const option = selected[i];
      const index = [].indexOf.call(this.listTopics, option);
      if (index >= selected.indexOf(option) + lengthDiff) {
        continue;
      }
      this.listTopics.add(option, index + 2);
    }
  }

  onClickButtonSave() {
    const hiddens = [];
    for (const option of this.listTopics.options) {
      hiddens.push(
        `<input type="hidden" name="topic_id[]" value="${option.value}" data-name="${option.innerText}" />`,
      );
    }
    this.form.insertAdjacentHTML("beforeend", hiddens.join("\n"));
  }

  /** @param {string} id */
  async fetchTopicInfo(id) {
    const response = await fetch(`/v2/topics/${id}`);

    /** @type {{name:string; banner:string | null; description:string|null}} */
    const json = await response.json();
    this.topicDetailTitle.innerText = json.name;
    this.topicDetailImage.src = json.banner || "";
    this.topicDetailDescription.innerText = json.description || "";
  }

  /** 画面の状態に応じて保存ボタンの状態を更新します */
  updateButtonsSave() {
    const forbidden = Array.from(this.listTopics.options).some((option) => {
      return option.matches(".is-forbidden");
    });

    this.buttonsSave.forEach((button) => (button.disabled = forbidden));
  }

  /** 画面の状態に応じて「使用可能なトピック」の各要素の表示状態を更新します */
  updateAvailableTopics() {
    const usedIds = Array.from(this.listTopics.querySelectorAll("option")).map(
      (option) => {
        return option.value;
      },
    );

    const availables = this.listAvailables.querySelectorAll("option");
    for (const option of availables) {
      if (usedIds.includes(option.value)) {
        option.classList.add("is-used");
      } else {
        option.classList.remove("is-used");
      }
    }
  }
}

window["TopicList"] = TopicList;
